<template>
  <BaseModal :modalTitle="$t('W: Vælg modtagelsesdato')">
    <div class="mb-4 flex flex-col gap-3">
      <div
        class="cursor-pointer rounded-lg border p-3 transition-colors"
        :class="mode === 'now' ? 'border-action bg-action-soft-bg' : 'border-border-subtle hover:border-border-strong'"
        @click="mode = 'now'">
        <span class="font-medium">{{ $t('W: Nu') }}</span>
        <p class="mt-0.5 text-sm text-text-muted">{{ $t('W: Bruger det aktuelle tidspunkt som TAT-startdato') }}</p>
      </div>

      <div
        class="cursor-pointer rounded-lg border p-3 transition-colors"
        :class="mode === 'custom' ? 'border-action bg-action-soft-bg' : 'border-border-subtle hover:border-border-strong'"
        @click="mode = 'custom'">
        <span class="font-medium">{{ $t('W: Tilpasset') }}</span>
        <p class="mt-0.5 text-sm text-text-muted">{{ $t('W: Vælg dato og tidspunkt manuelt') }}</p>

        <div v-if="mode === 'custom'" class="mt-3 flex gap-3" @click.stop>
          <input
            type="date"
            v-model="dateStr"
            class="rounded-md border border-border-subtle px-3 py-1.5 text-sm focus:border-action focus:outline-none" />
          <input
            type="time"
            v-model="timeStr"
            class="rounded-md border border-border-subtle px-3 py-1.5 text-sm focus:border-action focus:outline-none" />
        </div>
      </div>
    </div>

    <template #buttons>
      <UiBaseButton
        :text="$t('action.cancel')"
        theme="neutral"
        :isDisabled="isLoading"
        @button-click="$emit('close')" />
      <UiBaseButton
        :text="$t('action.continue')"
        theme="primary"
        :isLoading="isLoading"
        @button-click="onConfirmClick" />
    </template>
  </BaseModal>
</template>

<script lang="ts">
export default {
  name: 'RegisterSampleTatStartDateModal',

  emits: ['close'],

  props: {
    onConfirm: {
      type: Function,
      required: true,
    },
  },

  data() {
    const now = new Date()
    return {
      mode: 'now' as 'now' | 'custom',
      dateStr: `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`,
      timeStr: `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`,
      isLoading: false,
    }
  },

  methods: {
    async onConfirmClick() {
      let tatStartDate: number
      if (this.mode === 'now') {
        tatStartDate = Date.now()
      } else {
        const [year = 0, month = 0, day = 0] = this.dateStr.split('-').map(Number)
        const [hours = 0, minutes = 0] = this.timeStr.split(':').map(Number)
        tatStartDate = new Date(year, month - 1, day, hours, minutes).getTime()
      }
      this.isLoading = true
      try {
        await this.onConfirm(tatStartDate)
        this.$emit('close')
      } catch {
        // onConfirm handles its own error feedback; stay open for retry
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
